import React, { useEffect, useState } from 'react';
import { auth, db } from '../utils/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import AccountLayout from '../components/AccountLayout';

const inputCls = "w-full border border-border rounded-xl px-4 py-3 focus:outline-none focus:border-ring text-foreground placeholder:text-[var(--color-muted-foreground)] bg-card text-sm transition-colors";
const labelCls = "block text-xs font-bold text-[var(--color-muted-foreground)] uppercase tracking-wider mb-1.5";

const Field = ({ label, name, type = "text", placeholder, col, value, onChange }) => (
  <div className={col}>
    <label className={labelCls}>{label}</label>
    <input type={type} name={name} placeholder={placeholder} className={inputCls} value={value} onChange={onChange} />
  </div>
);

export default function ShippingAddress() {
  const user = auth.currentUser;
  const [address, setAddress] = useState({ businessName:'', street:'', city:'', state:'', zip:'', phone:'' });
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const snap = await getDoc(doc(db, 'users', user.uid));
        if (snap.exists()) {
          const d = snap.data();
          setAddress(a => ({
            ...a,
            businessName: d.businessName || '',
            street:       d.address      || '',
            city:         d.city         || '',
            state:        d.state        || '',
            zip:          d.zip          || '',
            phone:        d.phone        || '',
          }));
        }
      } catch (err) { console.error('Failed to load address:', err); }
    })();
  }, [user]);

  const handleChange = e => setAddress({ ...address, [e.target.name]: e.target.value });

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true); setMessage('');
    try {
      await setDoc(doc(db, 'users', user.uid), {
        businessName: address.businessName,
        address:      address.street,
        city:         address.city,
        state:        address.state,
        zip:          address.zip,
        phone:        address.phone,
      }, { merge: true });
      setMessage('Address saved successfully!'); setIsError(false);
    } catch (err) {
      setMessage(`Failed to save address. Please try again.`); setIsError(true);
    } finally { setLoading(false); }
  };

  return (
    <AccountLayout title="Shipping Address">
      <div className="max-w-lg">
        {message && (
          <div className={`mb-6 px-4 py-3 rounded-xl text-sm border ${isError ? "bg-red-50 border-red-200 text-red-700 dark:bg-red-950/30 dark:border-red-900/50 dark:text-red-400" : "bg-green-50 border-green-200 text-green-700 dark:bg-green-950/30 dark:border-green-900/50 dark:text-green-400"}`}>
            {message}
          </div>
        )}
        <div className="bg-card rounded-2xl border border-border shadow-sm p-7">
          <form onSubmit={handleSave} className="space-y-4">
            <Field label="Business Name"  name="businessName" placeholder="Smith Convenience LLC" value={address.businessName} onChange={handleChange} />
            <Field label="Street Address" name="street"       placeholder="123 Main St"            value={address.street}       onChange={handleChange} />
            <div className="grid grid-cols-2 gap-4">
              <Field label="City"  name="city"  placeholder="Dallas" value={address.city}  onChange={handleChange} />
              <Field label="State" name="state" placeholder="TX"     value={address.state} onChange={handleChange} />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <Field label="ZIP Code"     name="zip"   placeholder="75001"      value={address.zip}   onChange={handleChange} />
              <Field label="Phone Number" name="phone" type="tel" placeholder="2145551234" value={address.phone} onChange={handleChange} />
            </div>
            <button type="submit" disabled={loading} className="w-full bg-brand-navy hover:bg-brand-amber disabled:opacity-50 transition-colors text-white font-bold py-3.5 rounded-xl mt-2">
              {loading ? "Saving…" : "Save Address"}
            </button>
          </form>
        </div>
      </div>
    </AccountLayout>
  );
}
